<template>
    <div>
        <app-sub-title text="Respuestas lista de chequeo"></app-sub-title>
        <app-supervision-checklist-filters
            @filter="onFilter"
            :authors="authors"
        />
        <app-table-supervision-checklist
            :data="data"
            @change-page="onChangePage"
            @sort="onSort"
        />
    </div>
</template>

<script>
import TableSupervisionChecklist from './TableSupervisionChecklist/TableSupervisionChecklist.vue';
import SupervisionChecklistFilters from './SupervisionChecklistFilters/SupervisionChecklistFilters.vue';
import supervisionRepository from '../../../../repositories/supervision.repository';
import notebookRepository from '../../../../repositories/notebook.repository';

export default {
    components: {
        appTableSupervisionChecklist: TableSupervisionChecklist,
        appSupervisionChecklistFilters: SupervisionChecklistFilters
    },
    data(){
        return {
            data: {},
            sort: {
                sortBy: 'created_at',
                sortDir: 'desc'
            },
            authors: [],
            filters: {},
            page: 1,
        }
    },
    methods: {
        loadAuthorsAnnotations() {
        const nr = {...notebookRepository};
        nr
            .getAuthorsSupervisors()
            .then(data => (this.authors = data))
            .catch(error =>
                toastr.error( "Ocurrió un error al cargar los supervisores")
            );
        },
        loadHeadersBySupervisor() {
            const filters = {...this.filters, sortBy: this.sort.sortBy, sortDir: this.sort.sortDir};
            const sr = {...supervisionRepository};
            sr
                .loadChecklistHeadersBySupervisor(filters, this.page)
                .then(data => {
                    const checklists = data.data;
                    const fChecklists = checklists.map(item => {
                        const _rowDetails = true;
                        return {...item, _rowDetails};
                    });                
                    const theData = {...data, data: fChecklists};
                    this.data = theData;
                })
                .catch(error =>
                    toastr.error("Ocurrió un error al cargar las listas de chequeo")
                );
        },
        onFilter(filters){
            this.filters = filters;
            this.loadHeadersBySupervisor();
        },
        onChangePage(page){
            this.page = page;
            this.loadHeadersBySupervisor();
        },
        onSort(ctx) {
            this.sort.sortBy = ctx.sortBy;
            this.sort.sortDir = ctx.sortDir;
            this.loadHeadersBySupervisor();
        },
        initialize(){
            this.loadAuthorsAnnotations();
            this.loadHeadersBySupervisor();
        }
    },
    created(){
        this.initialize();
    }
}
</script>
